export const handleErrorMessage = (e: any) => {
    console.log(e)
    if (e?.networkError) {
        alert("Error de conexión")
    } else {
        alert(`${e?.message}`)
    }
}
